import {NgModule} from '@angular/core';
import {MkadCheckLevelDirective} from './directives';

@NgModule({
  declarations: [
    MkadCheckLevelDirective,
  ],
  imports: [],
  exports: [
    MkadCheckLevelDirective,
  ],
})
export class SharedModule {
}
